import React, { useContext } from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { ThemeContext } from 'styled-components';
import { BrandContext } from '@/contexts/ContextProviders';
// import styles from './dropdownHead.less?modules';

/**
 * 加载组件
 * @param {*} param
 */
const Loading = ({ loading, delay, ...props }) => {
  const themeContext = useContext(ThemeContext);
  const brandContext = useContext(BrandContext);
  const btn =
    themeContext &&
    themeContext[brandContext] &&
    themeContext[brandContext].btn;
  // console.log(btn);
  return (
    <Spin
      indicator={<LoadingOutlined />}
      // tip="Loading..."
      style={{ color: btn && btn.bgColor }}
      spinning={loading ? loading : false}
      delay={delay ? delay : 500}
    >
      {props.children}
    </Spin>
  );
};

export default Loading;
